const downgradeText = gettext("Downgrade");
const onlyAvailExpText = gettext("Only available after expiration.");
const DowngradePackageButton = () => {
    return (
        <React.Fragment>
            <button className="anp-button purchased full-width" disabled={true}>{downgradeText}</button>
            <div className="message-text-info">{onlyAvailExpText}</div>
        </React.Fragment>
    )
}

export default DowngradePackageButton;
